import {GetHealthCard, GetHealthCardModel, GetHealthCardParams} from 'domain/usecases';

import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteGetHealthCard implements GetHealthCard {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthCardModel>,
	) {}

	async get({signal}: GetHealthCardParams): Promise<GetHealthCardModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
